import React from 'react';


/**
 * Modal section that displays warnings to user.
 *
 * @param props.title String that contains the title of the warning box.
 * @param props.body String that contains the body text of the warning box.
 * @param props.insightMessage String that contains any additional insightful message.
 * @return JSX
 */
export function CdaWebModalWarningBox(props) {
    const {title, body, insightMessage} = props;

    return (
      <div className="cdaWebModalWarningBox">
        <h2>{title}</h2>
        {insightMessage && <div className="cdaWebModalPlotWarningMessageWithStatus">{insightMessage}</div>}
        <div className="cdaWebModalPlotWarningMessageWithStatus">{body.split('|n|').map(el=>(el.slice(0,3) !== "|t|" ? <div>{el}</div> : <div>&emsp;{el.replace("|t|","")}</div>))}</div>
      </div>
    )
}
